import { IState } from '../../../../store';

export function selectBlackFridayLabel(state: IState) {
  return state.offerData.offer.blackFriday?.label;
}
